<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1> {{title}} </h1>
  </div>
</div>
<nz-spin [nzSpinning]="isSpinning$ | async" nzSize="large" class="full-width">
  <div class="centered-box-vertical extralarge">
    <div nz-row nzJustify="space-between" class="withMargin">
      <div nz-col nzSpan=4>
        <button class="draftButton" nz-button nzType="primary" (click)="onCreate(draftCreateModal, draftCreateFooter)" *ngIf="canCreateDraft()">
          <i nz-icon nzType="plus"></i>
          Crea bozza
        </button>
      </div>
      <div nz-col [nzSpan]="9">
        <app-search [placeholderText]="'Cerca tra le bozze...'"></app-search>
      </div>
    </div>
    <div class="full-width">
      <nz-table #draftsData [nzData]="drafts | async"
        [nzFrontPagination]="false" [nzTotal]="total" [nzPageSize]="this.searchService.pageSize" [nzPageIndex]="this.searchService.pageIndex"
        (nzQueryParams)="onQueryParamsChange($event)" nzTableLayout="fixed"
      >
        <thead>
          <tr>
            <th nzColumnKey="id" [nzSortFn]="true">
              <span> Id richiesta </span>
            </th>
            <th class="middle-cell" nzColumnKey="fiscalCode" [nzSortFn]="true">
              <span> Codice fiscale </span>
            </th>
            <th class="middle-cell" nzColumnKey="email" [nzSortFn]="true">
              <span> Email </span>
            </th>
            <th class="middle-cell" nzColumnKey="status" [nzSortFn]="true" [nzFilters]="filterStatus" [nzFilterMultiple]="false" [nzFilterFn]="true">
              <span> Status </span>
            </th>
            <th class="end-cell" nzColumnKey="actions">
              <span class="with-margin"> Azioni </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let draft of draftsData.data">
            <td><p class="drafts">{{ draft.id }}</p></td>
            <td><p class="drafts">{{ draft.fiscalCode }}</p></td>
            <td><p class="drafts">{{ draft.email }}</p></td>
            <td><p class="drafts">{{ draft.status }}</p></td>
            <td *ngIf="!!allowedOperations.length">
              <span class="cell-content actions drafts" *ngIf="canDoAction(draft)">
                <button nz-button nz-dropdown [nzDropdownMenu]="requestActions" nzPlacement="bottomRight" nzTrigger="click">
                  <i nz-icon nzType="more" nzTheme="outline"></i>
                </button>
                <nz-dropdown-menu #requestActions="nzDropdownMenu">
                  <ul class="actions-list" nz-menu>
                    <li *ngIf="canBeCompiled(draft)"
                      i18n="Draft.DraftList.Compile|compile draft@@Draft.DraftList.Compile"
                      nz-menu-item (click)="compileDraft(draft)">
                      <i nz-icon [nzType]="'edit'" [nzTheme]="'twotone'" [nzTwotoneColor]="'gray'"></i>
                      Compila
                    </li>
                    <li *ngIf="canBeCancelled(draft)"
                      i18n="Draft.DraftList.Cancel|cancel draft@Draft.DraftList.Cancel"
                      nz-menu-item (click)="cancelDraft(draft.id)">
                      <i nz-icon [nzType]="'delete'" [nzTheme]="'twotone'" [nzTwotoneColor]="'red'"></i>
                      Cancella
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </span>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-spin>

<ng-template #draftCreateModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Draft.DraftCreate.ModalDescription|description for modal in draft create@@Draft.DraftCreate.ModalDescription">
    Inserisci nei campi sottostanti il codice fiscale e la e-mail al fine di poter creare una bozza di richiesta. </span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning$ | async">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="getFormGroup('draftCreate')" (ngSubmit)="createDraft()">
      <div nz-row nzJustify="start" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
            <nz-form-item class="login">
              <nz-form-control nzHasFeedback nzErrorTip="Inserire un codice fiscale valido">
                  <nz-input-group nzPrefixIcon="idcard" class="login">
                    <input nz-input name="ficalCode"
                      placeholder="Codice Fiscale" formControlName="fiscalCode" />
                  </nz-input-group>
              </nz-form-control>
            </nz-form-item>
        </div>
      </div>
      <div nz-row nzJustify="start" nzAlign="top">
        <div nz-col nzSpan="24" class="no-form">
            <nz-form-item class="login">
              <nz-form-control nzHasFeedback  [nzErrorTip]="getErrorCode('email', 'Inserire una e-mail valida')">
                  <nz-input-group nzPrefixIcon="mail" class="login">
                    <input nz-input name="email"
                      placeholder="Email" formControlName="email" />
                  </nz-input-group>
              </nz-form-control>
            </nz-form-item>
        </div>
      </div>
    </form>
  </nz-spin>
</ng-template>
<ng-template #draftCreateFooter>
  <div nz-row nzJustify="end">
    <div nz-col  nzSpan="5">
      <button class="submit" nz-button nzType="primary" (click)="createDraft()"
      [disabled]="getFormGroup('draftCreate').invalid"> CREA </button>
    </div>
  </div>
</ng-template>
